
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

const BlogPostStyles: React.FC = () => {
  const isMobile = useIsMobile();
  
  return (
    <style>
      {`
        .blog-content {
          white-space: pre-wrap;
          word-wrap: break-word;
          overflow-wrap: break-word;
        }
        
        .blog-content h1 {
          font-size: ${isMobile ? '1.35em' : '1.5em'};
          font-weight: bold;
          margin-bottom: 0.5em;
          margin-top: 1em;
        }
        
        .blog-content h2 {
          font-size: ${isMobile ? '1.15em' : '1.25em'};
          font-weight: bold;
          margin-bottom: 0.5em;
          margin-top: 1em;
        }
        
        .blog-content blockquote {
          border-left: 4px solid #e5e7eb;
          padding-left: 1em;
          font-style: italic;
          margin: 1em 0;
        }
        
        .blog-content pre {
          background-color: #f3f4f6;
          padding: 1em;
          border-radius: 0.5em;
          font-family: monospace;
          overflow: auto;
          margin: 1em 0;
          max-width: 100%;
          ${isMobile ? 'font-size: 0.9em;' : ''}
        }
        
        .blog-content code {
          background-color: #f3f4f6;
          padding: 0.2em 0.4em;
          border-radius: 0.25em;
          font-family: monospace;
          ${isMobile ? 'font-size: 0.9em;' : ''}
        }
        
        .blog-content ul {
          padding-left: 2em;
          margin: 1em 0;
          list-style-type: disc;
        }
        
        .blog-content ol {
          padding-left: 2em;
          margin: 1em 0;
          list-style-type: decimal;
        }
        
        .blog-content ul li,
        .blog-content ol li {
          margin-bottom: 0.5em;
        }
        
        .blog-content img {
          max-width: 100%;
          height: auto;
          margin: 1em 0;
        }
        
        .blog-content p {
          margin-bottom: 1em;
          ${isMobile ? 'font-size: 0.95em;' : ''}
        }
        
        .blog-content .chart-placeholder {
          background-color: #f3f4f6;
          border: 2px dashed #d1d5db;
          padding: 1.5em;
          text-align: center;
          margin: 1em 0;
          border-radius: 0.5em;
          color: #6b7280;
        }
        
        .blog-content.rtl {
          text-align: right;
        }
        
        .blog-content.rtl blockquote {
          border-left: none;
          border-right: 4px solid #e5e7eb;
          padding-left: 0;
          padding-right: 1em;
        }
        
        .blog-content.rtl ul,
        .blog-content.rtl ol {
          padding-left: 0;
          padding-right: 2em;
        }
        
        /* Mobile specific styles */
        .mobile-content {
          font-size: 16px !important;
          line-height: 1.6 !important;
        }
        
        .mobile-content h1 {
          font-size: 1.35em !important;
          margin-top: 1em !important;
          margin-bottom: 0.5em !important;
        }
        
        .mobile-content h2 {
          font-size: 1.15em !important;
          margin-top: 1em !important;
          margin-bottom: 0.5em !important;
        }
        
        .mobile-content h3 {
          font-size: 1em !important;
          margin-top: 1em !important;
          margin-bottom: 0.5em !important;
        }
        
        .mobile-content p {
          margin-bottom: 1em !important;
          font-size: 0.95em !important;
        }
        
        .mobile-content ul, 
        .mobile-content ol {
          padding-left: 1.5em !important;
          margin: 1em 0 !important;
        }
        
        .mobile-content.rtl ul,
        .mobile-content.rtl ol {
          padding-right: 1.5em !important;
          padding-left: 0 !important;
        }
        
        .mobile-content pre {
          padding: 0.75em !important;
          font-size: 0.85em !important;
          overflow-x: auto !important;
          white-space: pre-wrap !important;
        }
        
        .mobile-content img {
          width: 100% !important;
          height: auto !important;
          max-width: 100% !important;
        }
        
        .mobile-content blockquote {
          margin-left: 0 !important;
          margin-right: 0 !important;
          padding-left: 1em !important;
        }
        
        .mobile-content.rtl blockquote {
          padding-right: 1em !important;
          padding-left: 0 !important;
        }
        
        @media (max-width: 640px) {
          .blog-content {
            font-size: 16px;
            line-height: 1.6;
          }
          
          .blog-content h1 {
            font-size: 1.35em;
          }
          
          .blog-content h2 {
            font-size: 1.15em;
          }
          
          .blog-content ul, 
          .blog-content ol {
            padding-left: 1.5em;
          }
          
          .blog-content.rtl ul,
          .blog-content.rtl ol {
            padding-right: 1.5em;
          }
          
          .blog-content pre {
            padding: 0.75em;
            font-size: 0.85em;
          }
        }
      `}
    </style>
  );
};

export default BlogPostStyles;
